<script setup>
  import { storeToRefs } from "pinia";
  import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
    DialogDescription,
  } from "@/components/ui/dialog";
  import { Checkbox } from "@/components/ui/checkbox";
  import { Button } from "@/components/ui/button";
  import { useSyncMultiCountryModal } from "@stores/mSyncMultiCountryModal";

  const { isVisible, currentCountries, selectedCountries, isSyncing } = storeToRefs(useSyncMultiCountryModal());
  const { handleSync, handleSelection, hideModal } = useSyncMultiCountryModal();

  const isSelected = (country) => selectedCountries.value.includes(country.value);
</script>

<template>
  <Dialog
    :open="isVisible"
    @update:open="(val) => !val && hideModal()">
    <DialogContent
      :show-close-button="false"
      class="flex max-h-[90vh] flex-col font-sans sm:max-w-md">
      <DialogHeader class="shrink-0">
        <DialogTitle>Sync MultiCountry</DialogTitle>
        <DialogDescription>Select the countries you want to synchronize.</DialogDescription>
      </DialogHeader>

      <h4 class="shrink-0 text-sm font-medium">Countries</h4>
      <div class="min-h-0 flex-1 space-y-3 overflow-y-auto pr-1">
        <div
          v-for="country in currentCountries"
          :key="country.value"
          class="flex items-center gap-2">
          <Checkbox
            :id="`country-${country.value}`"
            :model-value="isSelected(country)"
            @update:model-value="handleSelection(country)" />
          <label
            :for="`country-${country.value}`"
            class="cursor-pointer text-sm">
            {{ country.label }} - {{ country.value }}
          </label>
        </div>
      </div>

      <DialogFooter class="shrink-0">
        <Button
          variant="outline"
          @click="hideModal">
          Cancel
        </Button>
        <Button
          :disabled="!selectedCountries.length || isSyncing"
          @click="handleSync">
          {{ isSyncing ? "Synchronizing..." : "Synchronize" }}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
